import React, { useState, useEffect } from "react";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { API, STRIPEPUBLICKEY } from "../../backend";
import authHeader from "../../services/auth-header";
import ManageUser from '../../Layouts/User';
import CreateClient from '../../Layouts/compnay/CreateClient';


const stripePromise = loadStripe(STRIPEPUBLICKEY);

const C = {
  primary: "#2563eb",
  primaryBg: "#eff6ff",
  text: "#111827",
  muted: "#6b7280",
  border: "#e5e7eb",
  bg: "#f9fafb",
  success: "#10b981",
  successBg: "#ecfdf5",
};

const S = {
  page: {
    color: C.text,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, Helvetica, Arial, sans-serif',
  },
  container: { maxWidth: 1100, margin: "0 auto" },
  titleBlock: { marginBottom: 22 },
  title: { fontSize: 28, fontWeight: 800, margin: "0 0 6px" },
  subtitle: { color: C.muted, fontSize: 14.5, margin: 0 },

  tabs: {
    display: "flex",
    gap: 8,
    borderBottom: `1px solid ${C.border}`,
    marginBottom: 40,
    flexWrap: "wrap",
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "12px 16px",
    fontWeight: 600,
    fontSize: 14,
    color: C.muted,
    border: "none",
    background: "transparent",
    borderBottom: "2px solid transparent",
    cursor: "pointer",
    marginBottom: -1,
  },
  tabActive: { color: C.primary, borderBottomColor: C.primary },

  plansGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: 24,
    maxWidth: 760,
    margin: "0 auto",
  },
  planCard: {
    position: "relative",
    background: "#fff",
    border: `1px solid ${C.border}`,
    borderRadius: 16,
    padding: "32px 28px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
  },
  planCardPopular: {
    border: `1.5px solid ${C.primary}`,
    boxShadow: "0 8px 24px rgba(37, 99, 235, 0.12)",
  },
  popularBadge: {
    position: "absolute",
    top: -13,
    left: "50%",
    transform: "translateX(-50%)",
    background: C.primaryBg,
    color: C.primary,
    fontSize: 12,
    fontWeight: 700,
    padding: "5px 14px",
    borderRadius: 999,
    border: "1px solid #dbeafe",
  },
  planTitle: { fontSize: 20, fontWeight: 800, margin: "0 0 10px" },
  planDesc: { color: C.muted, fontSize: 13.5, margin: "0 0 20px", minHeight: 40 },
  divider: { borderTop: `1px solid ${C.border}`, marginBottom: 20 },
  price: { fontSize: 34, fontWeight: 800, lineHeight: 1 },
  pricePeriod: { color: C.muted, fontSize: 13, marginBottom: 22 },
  featureList: {
    listStyle: "none",
    margin: "0 0 26px",
    padding: 0,
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: 11,
    flex: 1,
  },
  featureItem: { display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13.5 },
  featureIcon: { color: C.primary, marginTop: 3, fontSize: 12, flexShrink: 0 },

  btn: {
    border: "none",
    borderRadius: 10,
    padding: "11px 18px",
    fontWeight: 700,
    fontSize: 13.5,
    cursor: "pointer",
    width: "100%",
  },
  btnAuto: { width: "auto" },
  btnPrimary: { background: C.primary, color: "#fff" },
  btnOutline: { background: "#fff", color: C.primary, border: `1px solid ${C.primary}` },
  btnCurrent: { background: "#f3f4f6", color: C.muted, cursor: "default" },
  btnSm: { padding: "7px 14px", fontSize: 12.5 },

  footnote: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    marginTop: 32,
    fontSize: 13.5,
    color: C.text,
    flexWrap: "wrap",
    textAlign: "center",
  },
  footnoteIcon: {
    color: C.primary,
    background: C.primaryBg,
    width: 26,
    height: 26,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    flexShrink: 0,
  },
  subfootnote: { textAlign: "center", color: C.muted, fontSize: 12.5, marginTop: 8 },

  panel: {
    maxWidth: 820,
    margin: "0 auto",
    background: "#fff",
    border: `1px solid ${C.border}`,
    borderRadius: 16,
    padding: 28,
  },
  panelHead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 14,
    flexWrap: "wrap",
    marginBottom: 22,
  },
  panelTitle: { fontSize: 17, fontWeight: 800, margin: "0 0 4px" },
  panelDesc: { color: C.muted, fontSize: 13, margin: 0 },

  backLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    border: "none",
    background: "transparent",
    color: C.muted,
    fontSize: 13.5,
    fontWeight: 600,
    cursor: "pointer",
    marginBottom: 20,
    padding: 0,
  },
  checkoutGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
    gap: 24,
    marginBottom: 20,
  },
  planRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: `1px solid ${C.border}`,
    fontSize: 13.5,
    gap: 12,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 8,
  },
  termsBox: {
    background: C.primaryBg,
    border: "1px solid #dbeafe",
    borderRadius: 12,
    padding: 18,
    marginTop: 4,
  },
  tagPromo: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: C.successBg,
    color: C.success,
    padding: "6px 10px",
    borderRadius: 8,
    fontSize: 12.5,
    fontWeight: 700,
  },
  tagRemove: {
    border: "none",
    background: "transparent",
    color: "inherit",
    cursor: "pointer",
    fontSize: 14,
    lineHeight: 1,
    padding: 0,
  },
  formGroup: { marginBottom: 14 },
  formLabel: { display: "block", fontSize: 12, fontWeight: 700, marginBottom: 6 },
  formInput: {
    width: "100%",
    border: `1px solid ${C.border}`,
    borderRadius: 10,
    padding: "9px 12px",
    fontSize: 13.5,
    outline: "none",
  },
  formInputError: {
    borderColor: "#dc2626",
  },
  fieldErrorText: {
    color: "#dc2626",
    fontSize: 12,
    margin: "5px 0 0",
  },
};

const TABS = [
  { key: "plans", label: "Plans", icon: "fa-regular fa-rectangle-list" },
  { key: "license", label: "Manage License", icon: "fa-regular fa-id-badge" },
  { key: "accounts", label: "Accounts", icon: "fa-solid fa-users" },
];

const FREE_FEATURES = [
  "Single company workspace",
  "Up to 3 user accounts",
  "Core accounting & contract setup",
  "Standard receipt processing",
  "Basic reporting",
];

const PRO_FEATURES = [
  "Unlimited user accounts",
  "Advanced contract & data tape reports",
  "Automated periodic processing",
  "Priority receipts handling",
  "Consolidated reporting & analytics",
  "Priority phone & chat support",
];

function PaymentStep({ amount, onSuccess, onCancel }) {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setSubmitting(true);
    setError("");
    const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });
    if (confirmError) {
      setError(confirmError.message || "Payment failed. Please try again.");
      setSubmitting(false);
      return;
    }
    if (
      paymentIntent &&
      (paymentIntent.status === "succeeded" ||
        paymentIntent.status === "requires_capture")
    ) {
      onSuccess(paymentIntent);
    } else {
      setError("Payment was not confirmed. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement options={{ layout: "tabs" }} />
      {error && (
        <p style={{ color: "#dc2626", fontSize: 12.5, margin: "10px 0 0" }}>
          {error}
        </p>
      )}
      <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
        <button
          type="button"
          onClick={onCancel}
          disabled={submitting}
          style={{ ...S.btn, ...S.btnAuto, ...S.btnOutline }}
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={!stripe || submitting}
          style={{ ...S.btn, ...S.btnAuto, ...S.btnPrimary }}
        >
          {submitting ? "Confirming Payment..." : `Pay $${amount.toFixed(2)}`}
        </button>
      </div>
    </form>
  );
}

function SubscriptionDemo() {
  const [activeTab, setActiveTab] = useState("plans");
  const [currentPlan, setCurrentPlan] = useState("free");

  const [showPayment, setShowPayment] = useState(false);
  const [checkoutStep, setCheckoutStep] = useState("details"); // 'details' | 'payment' | 'success'
  const [paymentDataLoading, setPaymentDataLoading] = useState(false);
  const [preparingPayment, setPreparingPayment] = useState(false);
  const [creatingCompany, setCreatingCompany] = useState(false);
  const [createResult, setCreateResult] = useState(null);
  const [planPricing, setPlanPricing] = useState(null);
  const [clientSecret, setClientSecret] = useState("");

  const [subDetails, setSubDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
  });
  const [checkoutUsers, setCheckoutUsers] = useState(1);
  const [checkoutTerm, setCheckoutTerm] = useState(1);
  const [promoInput, setPromoInput] = useState("");
  const [promoApplied, setPromoApplied] = useState(null);
  const [promoError, setPromoError] = useState("");
  const [promoChecking, setPromoChecking] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [emailChecking, setEmailChecking] = useState(false);

  const proPrice = 100;

  const notify = (fn, msg) =>
    fn(msg, { position: "top-right", autoClose: 2500, theme: "light" });

  const handleGetStartedPro = async () => {
    setPaymentDataLoading(true);
    try {
      const planRes = await axios.get(
        API + "paymentsub/subplans/Annual/",
        { headers: authHeader() }
      );
      if (planRes.data && planRes.data.success) {
        setPlanPricing(planRes.data.response);
      }
      setSubDetails({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        companyName: "",
      });
      setCheckoutUsers(1);
      setCreateResult(null);
      setFieldErrors({});
      setTermsError(false);
      setCheckoutStep("details");
      setShowPayment(true);
    } catch (error) {
      notify(
        toast.error,
        "Couldn't load plan pricing for checkout. Please try again."
      );
    } finally {
      setPaymentDataLoading(false);
    }
  };

  const handleDowngrade = () => {
    setCurrentPlan("free");
    notify(toast.info, "Demo: switched to the Free plan");
  };

  const handleCancelPayment = () => {
    setShowPayment(false);
    setCheckoutStep("details");
    setPromoApplied(null);
    setPromoInput("");
    setPromoError("");
    setTermsAccepted(false);
    setTermsError(false);
    setFieldErrors({});
    setCreateResult(null);
    setClientSecret("");
  };

  const handleBackToDetails = () => {
    setCheckoutStep("details");
    setClientSecret("");
  };

  const handleApplyPromo = async () => {
    if (!promoInput.trim()) return;
    setPromoChecking(true);
    setPromoError("");
    try {
      const listRes = await axios.get(
        API + "paymentsub/subscription/promo_code/",
        { headers: authHeader() }
      );
      const codes = (listRes.data && listRes.data.data) || [];
      const match = codes.find((c) => c.promo_code === promoInput.trim());
      if (!match) {
        setPromoError("Invalid promotion code");
        setPromoApplied(null);
        return;
      }
      const detailRes = await axios.get(
        API + `paymentsub/subscription/promo_code/${match.id}`,
        { headers: authHeader() }
      );
      if (detailRes.data && detailRes.data.success) {
        setPromoApplied(detailRes.data.data);
        notify(toast.success, "Promotion code applied");
      } else {
        setPromoError(
          (detailRes.data &&
            (detailRes.data.response || detailRes.data.error)) ||
            "Invalid promotion code"
        );
        setPromoApplied(null);
      }
    } catch (error) {
      setPromoError("Invalid promotion code");
      setPromoApplied(null);
    } finally {
      setPromoChecking(false);
    }
  };

  const handleRemovePromo = () => {
    setPromoApplied(null);
    setPromoInput("");
    setPromoError("");
  };

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const REQUIRED_FIELD_LABELS = {
    firstName: "First name is required",
    lastName: "Last name is required",
    phone: "Contact number is required",
    companyName: "Company name is required",
  };

  const validateFields = () => {
    const errors = {};
    if (!subDetails.firstName.trim()) errors.firstName = REQUIRED_FIELD_LABELS.firstName;
    if (!subDetails.lastName.trim()) errors.lastName = REQUIRED_FIELD_LABELS.lastName;
    if (!subDetails.email.trim()) {
      errors.email = "Email is required";
    } else if (!EMAIL_RE.test(subDetails.email.trim())) {
      errors.email = "Enter a valid email address";
    }
    if (!subDetails.phone.trim()) errors.phone = REQUIRED_FIELD_LABELS.phone;
    if (!subDetails.companyName.trim()) errors.companyName = REQUIRED_FIELD_LABELS.companyName;
    return errors;
  };

  const handleFieldChange = (field) => (e) => {
    const value = e.target.value;
    setSubDetails((prev) => ({ ...prev, [field]: value }));
    if (fieldErrors[field]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    }
  };

  const handleRequiredFieldBlur = (field) => () => {
    if (!subDetails[field].trim() && REQUIRED_FIELD_LABELS[field]) {
      setFieldErrors((prev) => ({ ...prev, [field]: REQUIRED_FIELD_LABELS[field] }));
    }
  };

  // Same endpoint (accounting/uservalidation/) the marketing site's
  // checkout uses, called the same way: live as the user types, and again
  // right before we let them proceed, so a copy/paste + immediate submit
  // can't skip the check.
  const checkEmailExists = async (email) => {
    try {
      const res = await axios.post(
        API + "accounting/uservalidation/",
        { email },
        { headers: authHeader() }
      );
      if (res.data && res.data.success === 0) {
        const msg =
          res.data.response ||
          res.data.error ||
          res.data.message ||
          "This email is already registered";
        setFieldErrors((prev) => ({ ...prev, email: msg }));
        return false;
      }
      setFieldErrors((prev) => {
        if (!prev.email) return prev;
        const next = { ...prev };
        delete next.email;
        return next;
      });
      return true;
    } catch (error) {
      // Network hiccup on the live check — don't block typing; the
      // submit-time re-check below is the real gate.
      return true;
    }
  };

  useEffect(() => {
    const email = subDetails.email.trim();
    if (!email || !EMAIL_RE.test(email)) return undefined;
    setEmailChecking(true);
    const timer = setTimeout(() => {
      checkEmailExists(email).finally(() => setEmailChecking(false));
    }, 500);
    return () => {
      clearTimeout(timer);
      setEmailChecking(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subDetails.email]);

  const handleSubmitDetails = async (e) => {
    e.preventDefault();
    const errors = validateFields();
    setFieldErrors(errors);
    if (Object.keys(errors).length > 0) {
      notify(toast.error, "Please fix the highlighted fields");
      return;
    }
    if (!termsAccepted) {
      setTermsError(true);
      return;
    }
    setTermsError(false);
    if (totalPayable <= 0) {
      notify(toast.error, "Total payable must be greater than $0 to continue");
      return;
    }

    setPreparingPayment(true);
    try {
      const emailOk = await checkEmailExists(subDetails.email.trim());
      if (!emailOk) {
        notify(toast.error, "Please fix the highlighted fields");
        return;
      }
      const res = await axios.post(
        API + "paymentsub/subscription/create-payment-intent/",
        {
          amount: Math.round(totalPayable * 100),
          plan: (planPricing && planPricing.plan_name) || "Annual",
        },
        { headers: authHeader() }
      );
      if (res.data && res.data.clientSecret) {
        setClientSecret(res.data.clientSecret);
        setCheckoutStep("payment");
      } else {
        notify(
          toast.error,
          (res.data && res.data.error) || "Couldn't start the payment. Please try again."
        );
      }
    } catch (error) {
      notify(toast.error, "Couldn't start the payment. Please try again.");
    } finally {
      setPreparingPayment(false);
    }
  };

  const handlePaymentSuccess = async () => {
    setCreatingCompany(true);
    try {
      const res = await axios.post(
        API + "company/create-client/",
        {
          company_name: subDetails.companyName.trim(),
          email: subDetails.email.trim(),
          contact_name: `${subDetails.firstName.trim()} ${subDetails.lastName.trim()}`.trim(),
          phone_number: subDetails.phone.trim(),
          plan: (planPricing && planPricing.plan_name) || "Annual",
          no_of_users: checkoutUsers,
          total_amount: totalPayable,
          trial_days: (planPricing && planPricing.trial_period) || 0,
          subscription_type: "STRIPE",
        },
        { headers: authHeader() }
      );
      if (res.data && res.data.success === 1) {
        setCreateResult(res.data);
        setCheckoutStep("success");
      } else {
        notify(
          toast.error,
          (res.data && res.data.error) ||
            "Payment succeeded, but the company couldn't be created. Please contact support."
        );
      }
    } catch (error) {
      const backendError =
        error.response && error.response.data && error.response.data.error;
      notify(
        toast.error,
        backendError ||
          "Payment succeeded, but the company couldn't be created. Please contact support."
      );
    } finally {
      setCreatingCompany(false);
    }
  };


  const perUserAmount = planPricing ? Number(planPricing.per_user_amount) : proPrice;
  const trialDays = planPricing ? Number(planPricing.trial_period) || 0 : 0;
  const pricePerYear = perUserAmount * 12;
  const subTotal = pricePerYear * checkoutUsers * checkoutTerm;
  const discountAmount = promoApplied
    ? promoApplied.discount_type === "amount_off"
      ? Number(promoApplied.discount_value)
      : (subTotal * Number(promoApplied.discount_value)) / 100
    : 0;
  const totalPayable = Math.max(subTotal - discountAmount, 0);
  const expiryDate = (() => {
    const d = new Date();
    d.setDate(d.getDate() + trialDays);
    d.setFullYear(d.getFullYear() + checkoutTerm);
    return d;
  })();

  return (
    <div className="container-fluid py-4" style={S.page}>
      <ToastContainer />

      <div style={S.container}>
        <div style={S.titleBlock}>
          <h1 style={S.title}>Subscription</h1>
          <p style={S.subtitle}>Choose the plan that fits your business needs.</p>
        </div>

        {showPayment ? (
          <>
            {checkoutStep !== "success" && (
              <button
                type="button"
                style={S.backLink}
                onClick={
                  checkoutStep === "payment"
                    ? handleBackToDetails
                    : handleCancelPayment
                }
              >
                <i className="fa-solid fa-arrow-left" />
                {checkoutStep === "payment" ? "Back to Details" : "Back to Plans"}
              </button>
            )}

            {checkoutStep === "details" ? (
              <form onSubmit={handleSubmitDetails}>
                <div style={S.checkoutGrid}>
                  <div style={S.panel}>
                    <h3 style={S.planTitle}>
                      <span style={{ ...S.dot, background: C.success }} />
                      Subscriber's Details
                    </h3>
                    <p style={S.planDesc}>
                      We make payments easy. No need to negotiate with a
                      sales team.
                    </p>
                    <div style={S.formGroup}>
                      <label style={S.formLabel}>First Name *</label>
                      <input
                        style={{
                          ...S.formInput,
                          ...(fieldErrors.firstName ? S.formInputError : {}),
                        }}
                        value={subDetails.firstName}
                        onChange={handleFieldChange("firstName")}
                        onBlur={handleRequiredFieldBlur("firstName")}
                      />
                      {fieldErrors.firstName && (
                        <p style={S.fieldErrorText}>{fieldErrors.firstName}</p>
                      )}
                    </div>
                    <div style={S.formGroup}>
                      <label style={S.formLabel}>Last Name *</label>
                      <input
                        style={{
                          ...S.formInput,
                          ...(fieldErrors.lastName ? S.formInputError : {}),
                        }}
                        value={subDetails.lastName}
                        onChange={handleFieldChange("lastName")}
                        onBlur={handleRequiredFieldBlur("lastName")}
                      />
                      {fieldErrors.lastName && (
                        <p style={S.fieldErrorText}>{fieldErrors.lastName}</p>
                      )}
                    </div>
                    <div style={S.formGroup}>
                      <label style={S.formLabel}>Email ID *</label>
                      <input
                        type="email"
                        style={{
                          ...S.formInput,
                          ...(fieldErrors.email ? S.formInputError : {}),
                        }}
                        value={subDetails.email}
                        onChange={handleFieldChange("email")}
                      />
                      {emailChecking && (
                        <p style={S.subfootnote}>Checking email...</p>
                      )}
                      {fieldErrors.email && (
                        <p style={S.fieldErrorText}>{fieldErrors.email}</p>
                      )}
                    </div>
                    <div style={S.formGroup}>
                      <label style={S.formLabel}>Contact Number *</label>
                      <input
                        style={{
                          ...S.formInput,
                          ...(fieldErrors.phone ? S.formInputError : {}),
                        }}
                        value={subDetails.phone}
                        onChange={handleFieldChange("phone")}
                        onBlur={handleRequiredFieldBlur("phone")}
                      />
                      {fieldErrors.phone && (
                        <p style={S.fieldErrorText}>{fieldErrors.phone}</p>
                      )}
                    </div>
                    <div style={{ ...S.formGroup, marginBottom: 0 }}>
                      <label style={S.formLabel}>Company Name *</label>
                      <input
                        style={{
                          ...S.formInput,
                          ...(fieldErrors.companyName ? S.formInputError : {}),
                        }}
                        value={subDetails.companyName}
                        onChange={handleFieldChange("companyName")}
                        onBlur={handleRequiredFieldBlur("companyName")}
                      />
                      {fieldErrors.companyName && (
                        <p style={S.fieldErrorText}>{fieldErrors.companyName}</p>
                      )}
                    </div>
                  </div>

                  <div style={S.panel}>
                    <h3 style={S.planTitle}>
                      <span style={{ ...S.dot, background: "#ef4444" }} />
                      Your Plan
                    </h3>
                    <p style={S.planDesc}>
                      Please check your subscription cost carefully.
                    </p>

                    <div style={S.planRow}>
                      <span>Subscription Cost per User</span>
                      <strong>${perUserAmount}/Month</strong>
                    </div>
                    <div style={S.planRow}>
                      <span>Number of Users</span>
                      <select
                        style={{ ...S.formInput, width: "auto" }}
                        value={checkoutUsers}
                        onChange={(e) =>
                          setCheckoutUsers(Number(e.target.value))
                        }
                      >
                        {Array.from({ length: 10 }, (_, i) => i + 1).map(
                          (n) => (
                            <option key={n} value={n}>
                              {n} User{n > 1 ? "s" : ""}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <div style={S.planRow}>
                      <div>
                        <div>Term</div>
                        <div style={{ fontSize: 11.5, color: C.muted }}>
                          Expires on {expiryDate.toLocaleDateString()}
                        </div>
                      </div>
                      <select
                        style={{ ...S.formInput, width: "auto" }}
                        value={checkoutTerm}
                        onChange={(e) =>
                          setCheckoutTerm(Number(e.target.value))
                        }
                      >
                        <option value={1}>1 Year (12 Months)</option>
                        <option value={2}>2 Years (24 Months)</option>
                        <option value={3}>3 Years (36 Months)</option>
                      </select>
                    </div>
                    <div style={S.planRow}>
                      <span>Add-ons</span>
                      <span>$0.00</span>
                    </div>
                    <div style={S.planRow}>
                      <span>Promotion Code</span>
                      <div style={{ display: "flex", gap: 8 }}>
                        {promoApplied ? (
                          <span style={S.tagPromo}>
                            {promoApplied.promo_code}
                            <button
                              type="button"
                              style={S.tagRemove}
                              onClick={handleRemovePromo}
                            >
                              &times;
                            </button>
                          </span>
                        ) : (
                          <>
                            <input
                              style={{ ...S.formInput, width: 140 }}
                              placeholder="Enter code"
                              value={promoInput}
                              onChange={(e) => setPromoInput(e.target.value)}
                            />
                            <button
                              type="button"
                              style={{
                                ...S.btn,
                                ...S.btnAuto,
                                ...S.btnOutline,
                              }}
                              disabled={!promoInput.trim() || promoChecking}
                              onClick={handleApplyPromo}
                            >
                              {promoChecking ? "..." : "Apply"}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    {promoError && (
                      <p
                        style={{
                          color: "#dc2626",
                          fontSize: 12,
                          margin: "4px 0 0",
                        }}
                      >
                        {promoError}
                      </p>
                    )}
                    <div style={S.planRow}>
                      <span>Discount</span>
                      <span>${discountAmount.toFixed(2)}</span>
                    </div>
                    <div style={{ ...S.planRow, borderBottom: "none" }}>
                      <strong>Total Payable</strong>
                      <strong style={{ fontSize: 18 }}>
                        ${totalPayable.toFixed(2)}
                      </strong>
                    </div>
                  </div>
                </div>

                <div style={S.termsBox}>
                  <label
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                      fontSize: 13,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={termsAccepted}
                      onChange={(e) => {
                        setTermsAccepted(e.target.checked);
                        if (e.target.checked) setTermsError(false);
                      }}
                      style={{ marginTop: 3 }}
                    />
                    <span>
                      I agree to all the Terms and Conditions defined here.
                      {planPricing && (
                        <div
                          style={{
                            color: C.muted,
                            fontSize: 12,
                            marginTop: 4,
                          }}
                        >
                          Total payable amount will be charged after{" "}
                          {trialDays} days of free trial. You can cancel
                          anytime before the trial ends.
                        </div>
                      )}
                    </span>
                  </label>
                  {termsError && (
                    <p style={S.fieldErrorText}>
                      Please accept the terms and conditions
                    </p>
                  )}
                  <button
                    type="submit"
                    disabled={preparingPayment}
                    style={{
                      ...S.btn,
                      ...S.btnAuto,
                      ...S.btnPrimary,
                      marginTop: 14,
                    }}
                  >
                    {preparingPayment ? "Preparing Payment..." : "Continue to Payment"}
                  </button>
                </div>
              </form>
            ) : checkoutStep === "payment" ? (
              <div style={S.panel}>
                <h3 style={S.planTitle}>
                  <span style={{ ...S.dot, background: C.success }} />
                  Payment
                </h3>
                <p style={S.planDesc}>
                  Your company will only be created once this payment is
                  confirmed.
                </p>
                <div style={S.planRow}>
                  <span>Company</span>
                  <strong>{subDetails.companyName}</strong>
                </div>
                <div style={{ ...S.planRow, borderBottom: "none" }}>
                  <span>Amount due today</span>
                  <strong>${totalPayable.toFixed(2)}</strong>
                </div>
                <div style={{ marginTop: 18 }}>
                  {clientSecret && (
                    <Elements stripe={stripePromise} options={{ clientSecret }}>
                      <PaymentStep
                        amount={totalPayable}
                        onCancel={handleBackToDetails}
                        onSuccess={handlePaymentSuccess}
                      />
                    </Elements>
                  )}
                </div>
                {creatingCompany && (
                  <p style={{ ...S.subfootnote, textAlign: "left", marginTop: 14 }}>
                    Payment confirmed — creating your company...
                  </p>
                )}
              </div>
            ) : (
              <div style={S.panel}>
                <h3 style={S.planTitle}>
                  <span style={{ ...S.dot, background: C.success }} />
                  Company Created
                </h3>
                <p style={S.planDesc}>
                  {createResult && createResult.message}
                </p>
                <div style={S.planRow}>
                  <span>Company</span>
                  <strong>{createResult && createResult.client_company_name}</strong>
                </div>
                <div style={S.planRow}>
                  <span>Login email</span>
                  <strong>{createResult && createResult.client_email}</strong>
                </div>
                {createResult && createResult.subscription_num && (
                  <div style={{ ...S.planRow, borderBottom: "none" }}>
                    <span>Subscription #</span>
                    <strong>{createResult.subscription_num}</strong>
                  </div>
                )}
                <p style={{ ...S.subfootnote, textAlign: "left", marginTop: 14 }}>
                  Login credentials have been emailed to the address above.
                </p>
                <button
                  type="button"
                  style={{
                    ...S.btn,
                    ...S.btnAuto,
                    ...S.btnPrimary,
                    marginTop: 10,
                  }}
                  onClick={handleCancelPayment}
                >
                  Done
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <div style={S.tabs}>
              {TABS.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  style={{
                    ...S.tab,
                    ...(activeTab === tab.key ? S.tabActive : {}),
                  }}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <i className={tab.icon} />
                  {tab.label}
                </button>
              ))}
            </div>

            {activeTab === "plans" && (
              <>
                <div style={S.plansGrid}>
                  <div style={S.planCard}>
                    <h3 style={S.planTitle}>Free</h3>
                    <p style={S.planDesc}>
                      For small businesses just getting started.
                    </p>
                    <div style={S.divider} />
                    <div style={S.price}>$0</div>
                    <div style={S.pricePeriod}>/month</div>
                    <ul style={S.featureList}>
                      {FREE_FEATURES.map((f) => (
                        <li key={f} style={S.featureItem}>
                          <i className="fa-solid fa-check" style={S.featureIcon} />
                          {f}
                        </li>
                      ))}
                    </ul>
                    <button
                      type="button"
                      style={{
                        ...S.btn,
                        ...(currentPlan === "free" ? S.btnCurrent : S.btnOutline),
                      }}
                      disabled={currentPlan === "free"}
                      onClick={handleDowngrade}
                    >
                      {currentPlan === "free" ? "Current Plan" : "Downgrade"}
                    </button>
                  </div>

                  <div style={{ ...S.planCard, ...S.planCardPopular }}>
                    <span style={S.popularBadge}>Most Popular</span>
                    <h3 style={S.planTitle}>Professional</h3>
                    <p style={S.planDesc}>
                      For growing businesses that need more power and control.
                    </p>
                    <div style={S.divider} />
                    <div style={S.price}>${proPrice}</div>
                    <div style={S.pricePeriod}>/month</div>
                    <ul style={S.featureList}>
                      {PRO_FEATURES.map((f) => (
                        <li key={f} style={S.featureItem}>
                          <i className="fa-solid fa-check" style={S.featureIcon} />
                          {f}
                        </li>
                      ))}
                    </ul>
                    <button
                      type="button"
                      style={{
                        ...S.btn,
                        ...(currentPlan === "pro" ? S.btnCurrent : S.btnPrimary),
                      }}
                      disabled={currentPlan === "pro" || paymentDataLoading}
                      onClick={handleGetStartedPro}
                    >
                      {currentPlan === "pro"
                        ? "Current Plan"
                        : paymentDataLoading
                        ? "Loading..."
                        : "Get Started"}
                    </button>
                  </div>
                </div>

                <div style={S.footnote}>
                  <i className="fa-solid fa-shield-halved" style={S.footnoteIcon} />
                  All plans include secure hosting, automatic backups, and 99.9%
                  uptime.
                </div>
                <div style={S.subfootnote}>
                  Prices are in USD and billed monthly.
                </div>
              </>
            )}

            {activeTab === "license" && (

               <ManageUser />

            )}

            {activeTab === "accounts" && (

               <CreateClient />

            )}
          </>
        )}
      </div>
    </div>
  );
}

export default SubscriptionDemo;
